export default __webpack_public_path__ + "/images/BlankOne.cc5a4ae41a5b3598d3f9273d1954a0bd.png";